import { render, staticRenderFns } from "./VariantsRewardModal.vue?vue&type=template&id=a3dac314&scoped=true&"
import script from "./VariantsRewardModal.vue?vue&type=script&lang=js&"
export * from "./VariantsRewardModal.vue?vue&type=script&lang=js&"
import style0 from "./VariantsRewardModal.vue?vue&type=style&index=0&id=a3dac314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dac314",
  null
  
)

export default component.exports